import { useEffect } from "react";

/**
 * Assigns random shimmer delay & duration to each .shimmer-text element
 * so they don't all animate in sync. Re-runs on route changes via MutationObserver.
 */
export function useShimmerVariation() {
  useEffect(() => {
    const applyVariation = () => {
      const elements = document.querySelectorAll<HTMLElement>(".shimmer-text");
      elements.forEach((el) => {
        if (el.dataset.shimmerApplied) return;
        const delay = (Math.random() * 6).toFixed(2);
        const duration = (25 + Math.random() * 10).toFixed(2);
        el.style.setProperty("--shimmer-delay", `${delay}s`);
        el.style.setProperty("--shimmer-duration", `${duration}s`);
        el.dataset.shimmerApplied = "1";
      });
    };

    applyVariation();

    const observer = new MutationObserver(applyVariation);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);
}
